import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import { Row, Col } from 'react-bootstrap'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { AccordionBlock } from 'src/views/components'
import { CostCenterState } from './state'

import { CreateCostCenter } from './CreateCostCenter'

@observer
class CostCenterTable extends React.Component {
  @observable costId = ''
  @observable isActive = false

  costCenterState = new CostCenterState()
  renderFormatDate = data => {
    const locale = getLocaleCodeFromUrl({
      defaultLocale: 'en_US',
      isReverseType: true,
    })

    const convertedEndDate = new Date(data).toLocaleDateString(
      locale?.replace('_', '-') || 'en-GB'
    )
    return convertedEndDate
  }
  renderBudgetDetails = budgetData => {
    const startDate = this.renderFormatDate(budgetData.startDate)
    const endDate = this.renderFormatDate(budgetData.endDate)

    return (
      <>
        {/* <Col>{budgetData.budgetPeriod}</Col> */}
        <Row noGutters className="costcenter-list mb-1">
          <span className="cost-colon-align-right">
            {i18nTranslate('costCenter.duration', 'Duration')}
          </span>
          :
          <span className="duration-text ml-1">
            {' '}
            {startDate} to {endDate}
          </span>
        </Row>
      </>
    )
  }

  getActiveBudget = budgets => {
    const activeBudget = budgets.find(list => list.endDate >= Date.now())
    return activeBudget
  }

  renderCostCenter = (cost, isVisible) => {
    const budgets = cost?.budgets || []
    const defaultBudget = cost?.budgets?.[0] || []
    const findActiveBudget = this.getActiveBudget(budgets)
    const activeBudget =
      findActiveBudget !== undefined ? findActiveBudget : defaultBudget
    const statusColor =
      cost.status && cost.status.toLowerCase() === 'active'
        ? 'text-success'
        : 'text-danger'
    const statusText =
      cost.status.toLowerCase() === 'active'
        ? i18nTranslate('status.active', 'Active')
        : i18nTranslate('status.inActive', 'Inactive')
    const totalBudget =
      findActiveBudget === undefined
        ? 0
        : activeBudget.totalBudget
        ? activeBudget.totalBudget
        : 0
    const usedBudget =
      findActiveBudget === undefined
        ? 0
        : activeBudget.usedBudget
        ? activeBudget.usedBudget
        : 0
    const availableBudget = totalBudget - usedBudget
    const availableBudgetFixed = parseFloat(availableBudget).toFixed(2)
    return (
      <Row noGutters className="cost-center-table-header pb-2">
        <Col lg={6} className="d-flex flex-column p-0">
          <Row
            noGutters
            className="costcenter-list mb-1"
            data-testid="qa-costcenter-id">
            <span className="cost-colon-align-left">
              {i18nTranslate('costcenter.id', 'Cost Center ID')}
            </span>
            :<span className="ml-1"> {cost.id}</span>
          </Row>
          <Row
            noGutters
            className="costcenter-list mb-1"
            data-testid="qa-costcenter-name">
            <span className="cost-colon-align-left">
              {i18nTranslate('costcenter.name', 'Cost Center Name')}
            </span>
            : <span className="ml-1">{cost.name}</span>
          </Row>
          <Row
            noGutters
            className="costcenter-list mb-1"
            data-testid="qa-costcenter-status">
            <span className="cost-colon-align-left">
              {i18nTranslate('costcenter.Status', 'Status')}
            </span>
            :<span className={`${statusColor} ml-1`}> {statusText}</span>
          </Row>
        </Col>

        {/* To be changed based on response */}
        {isVisible === false && (
          <Col lg={6} className="d-flex flex-column">
            <Row noGutters className="costcenter-list mb-1">
              <span className="cost-colon-align-right">
                {i18nTranslate('costcenter.totalBudgetTable', 'Total Budget')}
              </span>
              :{' '}
              <span className="ml-1">
                {this.costCenterState.currencyCode}
                {totalBudget}
              </span>
            </Row>
            <Row noGutters className="costcenter-list mb-1">
              <span className="cost-colon-align-right">
                {i18nTranslate(
                  'costcenter.availableBudget',
                  'Available Budget'
                )}
              </span>
              :{' '}
              <span className="ml-1">
                {this.costCenterState.currencyCode}
                {availableBudgetFixed}
              </span>
            </Row>
            {isVisible === false &&
              budgets &&
              budgets.length > 0 &&
              this.renderBudgetDetails(activeBudget)}
          </Col>
        )}
      </Row>
    )
  }
  handleVisibility = props => {
    this.costId = props.index
    this.isActive = props.isOpen
  }
  renderAccordion = data => {
    // const { isActive } = this.props
    const isVisible = this.costId === data.id && this.isActive
    return (
      <div
        className="cost-center-table bg-white mb-2"
        key={`${data.id}-${data - name}`}>
        <AccordionBlock
          title={this.renderCostCenter(data, isVisible)}
          key={data.id}
          className="accordion-block-cost-center"
          index={data.id}
          isActive={isVisible}
          onClick={this.handleVisibility}>
          <CreateCostCenter
            data={data}
            isEditForm={true}
            handleVisibility={this.handleVisibility}
            {...this.props}
          />
        </AccordionBlock>
      </div>
    )
  }
  render() {
    const { list } = this.props
    const view = list && list.length > 0 && list.map(this.renderAccordion)
    return view
  }
}

export default CostCenterTable
export { CostCenterTable }
